/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.geo', [])
    .factory('geoService', GeoService)
    .name;

/*@ngInject*/
function GeoService($http, $q) {
    var service = {
        getLocalization: getLocalization,
        getResolverConfiguration: getResolverConfiguration,
        createResolverConfiguration: createResolverConfiguration,
        saveResolverConfiguration: saveResolverConfiguration,
        getDefaultResolverConfiguration: getDefaultResolverConfiguration,
        getAlgorithmConfiguration: getAlgorithmConfiguration,
        createAlgorithmConfiguration: createAlgorithmConfiguration,
        saveAlgorithmConfiguration: saveAlgorithmConfiguration,
        getDefaultAlgorithmConfiguration: getDefaultAlgorithmConfiguration,
    };

    return service;

    function getLocalization (dev_id, mobility, startTs, endTs) {
        var deferred = $q.defer();
        var start_time = +((startTs / 1000).toFixed(3));
        var end_time = +((endTs / 1000).toFixed(3));

        const params = {
            dev_id,
            mobility,
            end_time,
            start_time,
        };

        $http.post(`/api/geo/localization/ftmc`, params).then(function success(response) {
            if (response.data.loc_est && !mobility) {
                deferred.resolve({
                    loc_est: [response.data.loc_est],
                    warnings: response.data.warnings
                });
            }
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function getResolverConfiguration (customerId) {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/resolver/' + customerId;

        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function createResolverConfiguration (customerId, data) {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/resolver/' + customerId;

        $http.post(url, data).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function saveResolverConfiguration (customerId, data) {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/resolver/' + customerId;

        $http.put(url, data).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function getDefaultResolverConfiguration() {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/resolver/default';

        $http.get(url).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function getAlgorithmConfiguration (customerId) {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/algorithm/' + customerId;

        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function createAlgorithmConfiguration (customerId, data) {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/algorithm/' + customerId;

        $http.post(url, data).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function saveAlgorithmConfiguration (customerId, data) {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/algorithm/' + customerId;

        $http.put(url, data).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }

    function getDefaultAlgorithmConfiguration() {
        var deferred = $q.defer();
        var url = '/api/geo/configuration/ftmc/algorithm/default';

        $http.get(url).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });

        return deferred.promise;
    }
}




// WEBPACK FOOTER //
// ./src/app/api/geo.service.js